import {
  useGetLvdStandardsRecommendations,
  useReplaceLvdConfirmedStandards,
} from '@/shared/hooks/api/lvdComplianceFiles'
import { ConfirmedHarmonisedStandardsEditSheet } from '@/v2/components/product-compliance-briefing/ConfirmedHarmonisedStandardsEditSheet'
import type { ConfirmedLvdStandard } from '@/v2/utils/lvdLegislationBriefing'

type V2LvdConfirmedStandardsEditSheetProps = {
  productId: string
  standards: ConfirmedLvdStandard[]
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function V2LvdConfirmedStandardsEditSheet({
  productId,
  standards,
  open,
  onOpenChange,
}: V2LvdConfirmedStandardsEditSheetProps) {
  const { mutateAsync: replaceStandards, isPending: isSaving } =
    useReplaceLvdConfirmedStandards(productId)
  const {
    mutateAsync: fetchRecommendations,
    isPending: isLoadingRecommendations,
  } = useGetLvdStandardsRecommendations(productId)

  return (
    <ConfirmedHarmonisedStandardsEditSheet
      standards={standards}
      open={open}
      onOpenChange={onOpenChange}
      i18nKeyPrefix='v2.pages.products.detail.lvdBriefing.confirmedStandards'
      isSaving={isSaving}
      isLoadingRecommendations={isLoadingRecommendations}
      onSave={async (nextStandards) => {
        await replaceStandards({ standards: nextStandards })
      }}
      onFetchRecommendations={async () => {
        const result = await fetchRecommendations()
        return result.standards
      }}
    />
  )
}
